
export const useAppraisalActions = (
  appraisalState: any,
  userIsSupervisor: boolean,
  teamMembers: any[],
  calculateAppraisalMetrics: () => void,
  triggerRefresh: () => void
) => {
  const handleEditSelfRating = (goal: any) => {
    appraisalState.setSelectedGoal(goal);
    appraisalState.setEditDialogOpen(true);
  };

  const handleEditManagerRating = (goal: any) => {
    appraisalState.setSelectedGoal(goal);
    appraisalState.setEditManagerDialogOpen(true);
  };

  const handleSelfRatingChange = (goalId: string, value: string) => {
    appraisalState.setGoalSelfRatings((prev: any) => ({
      ...prev,
      [goalId]: value
    }));
  };

  const handleManagerRatingChange = (goalId: string, value: string) => {
    appraisalState.setGoalManagerRatings((prev: any) => ({
      ...prev,
      [goalId]: value
    }));
  };

  const handleSaveSuccess = (goalId: string) => {
    appraisalState.setSavedGoals((prev: Set<string>) => new Set([...prev, goalId]));
    // Trigger refresh to reload the latest data including comments
    triggerRefresh();
  };

  const handleManagerSaveSuccess = (goalId: string) => {
    appraisalState.setSavedManagerGoals((prev: Set<string>) => new Set([...prev, goalId]));
    if (userIsSupervisor && teamMembers.length > 0) {
      calculateAppraisalMetrics();
    }
    // Trigger refresh to reload the latest data including comments
    triggerRefresh();
  };

  return {
    handleEditSelfRating,
    handleEditManagerRating,
    handleSelfRatingChange,
    handleManagerRatingChange,
    handleSaveSuccess,
    handleManagerSaveSuccess
  };
};
